import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from '@material-ui/lab/Skeleton';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: theme.spacing(2, 3),
  },
  imageContainer: {
    width: theme.spacing(6.5),
    height: theme.spacing(6.5),
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    margin: theme.spacing(1),
  },
}));

const ImageListShimmer = ({ imageType, count, animation }) => {
  const classes = useStyles();

  return Array(count)
    .fill('')
    .map((e, i) => (
      <div className={classes.container} key={i}>
        <Skeleton
          variant={imageType}
          className={classes.imageContainer}
          animation={animation}
        />
        <div className={classes.textContainer}>
          <Skeleton variant="text" width="35%" animation={animation} />
          <Skeleton variant="text" width="20%" animation={animation} />
          <Skeleton variant="text" width={'50%'} animation={animation} />
        </div>
      </div>
    ));
};

ImageListShimmer.propTypes = {
  imageType: PropTypes.oneOf(['circle', 'rect']),
  animation: PropTypes.oneOf(['animation', 'pulse', 'wave']),
  count: PropTypes.number,
};

ImageListShimmer.defaultProps = {
  imageType: 'circle',
  animation: 'wave',
  count: 1,
};

export default ImageListShimmer;
